import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RoleSelectionModal from './pages/role-selection-modal';
import ContactPage from './pages/contact';
import ProfileUnlockPayment from './pages/profile-unlock-payment';
import EmployerSearchInterface from './pages/employer-search-interface';
import JobSeekerDashboard from './pages/job-seeker-dashboard';
import EmployerRegistration from './pages/employer-registration';
import EmployerDashboard from './pages/employer-dashboard';
import Homepage from './pages/homepage';
import JobSeekerRegistration from './pages/job-seeker-registration';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/role-selection-modal" element={<RoleSelectionModal />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/profile-unlock-payment" element={<ProfileUnlockPayment />} />
        <Route path="/employer-search-interface" element={<EmployerSearchInterface />} />
        <Route path="/job-seeker-dashboard" element={<JobSeekerDashboard />} />
        <Route path="/employer-registration" element={<EmployerRegistration />} />
        <Route path="/employer-dashboard" element={<EmployerDashboard />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/job-seeker-registration" element={<JobSeekerRegistration />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
